import React, { useEffect } from 'react';
import { Landing } from './pages/Landing';
import { initMetaPixel } from './utils/metaPixel';
import { setupPage } from './utils/pageSetup';
export function App() {
  useEffect(() => {
    setupPage();

    // Keep analytics off the critical path so it never delays LCP.
    const idle = (cb: () => void) => {
      const w = window as Window & {
        requestIdleCallback?: (cb: () => void) => number;
      };
      if (typeof w.requestIdleCallback === 'function') {
        w.requestIdleCallback(cb);
      } else {
        window.setTimeout(cb, 2500);
      }
    };
    idle(() => initMetaPixel());
  }, []);
  return <Landing data-id="element-0" data-mp="31bs1ff0jszn8" />;
}